/** Version du SDK, injectée au build depuis package.json (`define` de vite.config.ts). */
declare const __SDK_VERSION__: string

export const SDK_VERSION = __SDK_VERSION__
